import * as React from "react"
import { cva } from "class-variance-authority"
import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "tw:inline-flex tw:items-center tw:rounded-full tw:border tw:border-gray-200 tw:px-2.5 tw:py-0.5 tw:text-xs tw:font-medium tw:transition-colors",
  {
    variants: {
      variant: {
        default: "tw:border-transparent tw:bg-brand-secondary tw:text-white",
        secondary: "tw:border-transparent tw:bg-gray-100 tw:text-gray-900",
        destructive: "tw:border-transparent tw:bg-red-100 tw:text-red-700",
        outline: "tw:text-gray-700 tw:border-gray-300",
        success: "tw:border-transparent tw:bg-green-100 tw:text-green-700",
        warning: "tw:border-transparent tw:bg-yellow-100 tw:text-yellow-700",
      },
    },
    defaultVariants: { variant: "default" },
  }
)

function Badge({ className, variant, ...props }) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />
}

export { Badge, badgeVariants }
